import * as React from 'react';
import {
	RadioButtonGroup as RadioButtonGroupCore,
	IRadioButtonGroupProps as IRadioButtonGroupPropsCore
} from '../core/radio-button-group';

import styles from './radio-button-group.module.scss';
import radioButtonStyles from '../radio-button/radio-button.module.scss';

export interface IRadioButtonGroupProps extends IRadioButtonGroupPropsCore {}

const RadioButtonGroup = (props: IRadioButtonGroupProps): React.JSX.Element => {
	return <RadioButtonGroupCore {...props} propStyles={styles} radioButtonStyles={radioButtonStyles} />;
};

export { RadioButtonGroup };
